var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", { staticClass: "liveinfo-form", attrs: { "no-body": "" } }, [
        _c(
          "div",
          { staticClass: "m-2" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "제약사" } },
                      [
                        _c("b-form-input", {
                          attrs: { readonly: "" },
                          model: {
                            value: _vm.drugInfoData.clientName,
                            callback: function ($$v) {
                              _vm.$set(_vm.drugInfoData, "clientName", $$v)
                            },
                            expression: "drugInfoData.clientName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "제목" } },
                      [
                        _c("b-form-input", {
                          attrs: { readonly: "" },
                          model: {
                            value: _vm.drugInfoData.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.drugInfoData, "title", $$v)
                            },
                            expression: "drugInfoData.title",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.drugInfoData.drugInfoType === 1
                  ? _c(
                      "b-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "컨텐츠", "label-for": "" } },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "mr-sm-50",
                                attrs: { variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    _vm.showModal = true
                                  },
                                },
                              },
                              [_c("span", [_vm._v("미리보기")])]
                            ),
                            _c(
                              "b-modal",
                              {
                                attrs: {
                                  id: "drugInfoPreview",
                                  title: "HTML 미리보기",
                                },
                                model: {
                                  value: _vm.showModal,
                                  callback: function ($$v) {
                                    _vm.showModal = $$v
                                  },
                                  expression: "showModal",
                                },
                              },
                              [
                                _c("iframe", {
                                  ref: "previewFrame",
                                  staticStyle: { "background-color": "white" },
                                  attrs: {
                                    srcdoc: _vm.drugInfoData.htmlContent,
                                    frameborder: "0",
                                    "max-width": "1150px",
                                    width: "1115px",
                                    height: "1000px",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.drugInfoData.drugInfoType === 2
                  ? _c(
                      "b-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "미리보기", "label-for": "" } },
                          [
                            _vm.drugInfoData.tabContent1
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "mr-sm-50",
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function ($event) {
                                        _vm.detailTabView1 = true
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("컨텐츠1")])]
                                )
                              : _vm._e(),
                            _c(
                              "b-modal",
                              {
                                attrs: {
                                  id: "drugInfoPreview",
                                  title: "HTML 미리보기",
                                },
                                model: {
                                  value: _vm.detailTabView1,
                                  callback: function ($$v) {
                                    _vm.detailTabView1 = $$v
                                  },
                                  expression: "detailTabView1",
                                },
                              },
                              [
                                _c("iframe", {
                                  ref: "previewFrame",
                                  staticStyle: { "background-color": "white" },
                                  attrs: {
                                    srcdoc: _vm.drugInfoData.tabContent1,
                                    frameborder: "0",
                                    "max-width": "1150px",
                                    width: "1115px",
                                    height: "1000px",
                                  },
                                }),
                              ]
                            ),
                            _vm.drugInfoData.tabContent2
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "mr-sm-50",
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function ($event) {
                                        _vm.detailTabView2 = true
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("컨텐츠2")])]
                                )
                              : _vm._e(),
                            _c(
                              "b-modal",
                              {
                                attrs: {
                                  id: "drugInfoPreview",
                                  title: "HTML 미리보기",
                                },
                                model: {
                                  value: _vm.detailTabView2,
                                  callback: function ($$v) {
                                    _vm.detailTabView2 = $$v
                                  },
                                  expression: "detailTabView2",
                                },
                              },
                              [
                                _c("iframe", {
                                  ref: "previewFrame",
                                  staticStyle: { "background-color": "white" },
                                  attrs: {
                                    srcdoc: _vm.drugInfoData.tabContent2,
                                    frameborder: "0",
                                    "max-width": "1150px",
                                    width: "1115px",
                                    height: "1000px",
                                  },
                                }),
                              ]
                            ),
                            _vm.drugInfoData.tabContent3
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "mr-sm-50",
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function ($event) {
                                        _vm.detailTabView3 = true
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("컨텐츠3")])]
                                )
                              : _vm._e(),
                            _c(
                              "b-modal",
                              {
                                attrs: {
                                  id: "drugInfoPreview",
                                  title: "HTML 미리보기",
                                },
                                model: {
                                  value: _vm.detailTabView3,
                                  callback: function ($$v) {
                                    _vm.detailTabView3 = $$v
                                  },
                                  expression: "detailTabView3",
                                },
                              },
                              [
                                _c("iframe", {
                                  ref: "previewFrame",
                                  staticStyle: { "background-color": "white" },
                                  attrs: {
                                    srcdoc: _vm.drugInfoData.tabContent3,
                                    frameborder: "0",
                                    "max-width": "1150px",
                                    width: "1115px",
                                    height: "1000px",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "처방 팝업 조건(약품)" } },
                      [
                        _c("b-form-input", {
                          attrs: { readonly: "" },
                          model: {
                            value: _vm.drugInfoData.condDrugCodes,
                            callback: function ($$v) {
                              _vm.$set(_vm.drugInfoData, "condDrugCodes", $$v)
                            },
                            expression: "drugInfoData.condDrugCodes",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "처방 팝업 조건(질병)" } },
                      [
                        _c("b-form-input", {
                          attrs: { readonly: "" },
                          model: {
                            value: _vm.drugInfoData.condDiseaseCodes,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.drugInfoData,
                                "condDiseaseCodes",
                                $$v
                              )
                            },
                            expression: "drugInfoData.condDiseaseCodes",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "처방 팝업 조건(검사)" } },
                      [
                        _c("b-form-input", {
                          attrs: { readonly: "" },
                          model: {
                            value: _vm.drugInfoData.condLabCodes,
                            callback: function ($$v) {
                              _vm.$set(_vm.drugInfoData, "condLabCodes", $$v)
                            },
                            expression: "drugInfoData.condLabCodes",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "3" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "컨텐츠 게시 기간(Fr)" } },
                      [
                        _c("b-form-datepicker", {
                          attrs: { placeholder: "게시기간(Fr)", disabled: "" },
                          model: {
                            value: _vm.drugInfoData.startDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.drugInfoData, "startDate", $$v)
                            },
                            expression: "drugInfoData.startDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "3" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "컨텐츠 게시 기간(To)" } },
                      [
                        _c("b-form-datepicker", {
                          attrs: { placeholder: "게시기간(Fr)", disabled: "" },
                          model: {
                            value: _vm.drugInfoData.endDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.drugInfoData, "endDate", $$v)
                            },
                            expression: "drugInfoData.endDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "3" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "처방팝업 게시 기간(Fr)" } },
                      [
                        _c("b-form-datepicker", {
                          attrs: { placeholder: "게시기간(Fr)", disabled: "" },
                          model: {
                            value: _vm.drugInfoData.ipuStartDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.drugInfoData, "ipuStartDate", $$v)
                            },
                            expression: "drugInfoData.ipuStartDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "3" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "처방팝업 게시 기간(To)" } },
                      [
                        _c("b-form-datepicker", {
                          attrs: { placeholder: "게시기간(Fr)", disabled: "" },
                          model: {
                            value: _vm.drugInfoData.ipuEndDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.drugInfoData, "ipuEndDate", $$v)
                            },
                            expression: "drugInfoData.ipuEndDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "3" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "스케줄팝업 게시 기간(Tr)" } },
                      [
                        _c("b-form-datepicker", {
                          attrs: { placeholder: "게시기간(Fr)", disabled: "" },
                          model: {
                            value: _vm.drugInfoData.spuStartDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.drugInfoData, "spuStartDate", $$v)
                            },
                            expression: "drugInfoData.spuStartDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "3" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "스케줄팝업 게시 기간(To)" } },
                      [
                        _c("b-form-datepicker", {
                          attrs: { placeholder: "게시기간(Fr)", disabled: "" },
                          model: {
                            value: _vm.drugInfoData.spuEndDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.drugInfoData, "spuEndDate", $$v)
                            },
                            expression: "drugInfoData.spuEndDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("b-col", { attrs: { cols: "12", md: "4" } }),
          ],
          1
        ),
      ]),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-tabs",
            { staticClass: "m-2", attrs: { pills: "" } },
            [
              false
                ? _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  staticClass: "mr-0 mr-sm-50",
                                  attrs: {
                                    icon: "MessageSquareIcon",
                                    size: "16",
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "d-none d-sm-inline" },
                                  [_vm._v("댓글 상세 정보")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1573114609
                      ),
                    },
                    [
                      _c("comment-info-view", {
                        attrs: { "live-info-id": _vm.liveInfoId },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              false
                ? _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  staticClass: "mr-0 mr-sm-50",
                                  attrs: { icon: "UsersIcon", size: "16" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "d-none d-sm-inline" },
                                  [_vm._v("방문 신청 상세 정보")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3022053878
                      ),
                    },
                    [
                      _c("visit-ask-view", {
                        attrs: { "live-info-id": _vm.liveInfoId },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              false
                ? _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  staticClass: "mr-0 mr-sm-50",
                                  attrs: { icon: "GiftIcon", size: "16" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "d-none d-sm-inline" },
                                  [_vm._v("샘플 신청 상세 정보")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3098026477
                      ),
                    },
                    [
                      _c("sample-ask-view", {
                        attrs: { "live-info-id": _vm.liveInfoId },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              false
                ? _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  staticClass: "mr-0 mr-sm-50",
                                  attrs: { icon: "EditIcon", size: "16" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "d-none d-sm-inline" },
                                  [_vm._v("이메일 답변 신청 상세 정보")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        536762128
                      ),
                    },
                    [
                      _c("email-ask-view", {
                        attrs: { "live-info-id": _vm.liveInfoId },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-tab",
                {
                  attrs: { active: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("feather-icon", {
                            staticClass: "mr-0 mr-sm-50",
                            attrs: { icon: "Share2Icon", size: "16" },
                          }),
                          _c("span", { staticClass: "d-none d-sm-inline" }, [
                            _vm._v("통계 상세 정보"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("drugInfo-click-View", {
                    attrs: {
                      "live-info-id": _vm.liveInfoId,
                      "start-date": new Date(_vm.drugInfoData.startDate),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }